import * as DKFDS from 'dkfds';
import $ from 'jquery';

function selectedCount() {
    return $('input[type="checkbox"][name="selectedCases"]:checked').length;
}

function onClick() {
    if (selectedCount() === 0) {
        new DKFDS.Toast(document.getElementById('signinCasesError')).show();
    }
    else {
        new DKFDS.Modal(document.getElementById('signinCasesModal')).show();
    }
}

function onShowModal() {
    const noCases = selectedCount();
    const casesText = noCases === 1 ? 'sag' : 'sager';
    $('#signinCasesModalText').html(`Du er i gang med at tilmelde ${noCases} ${casesText}.`);
    $('#signinCasesModalOK').one('click', () => {
        $('#signinCasesLoading').show();
        $('form').append('<input type="hidden" name="doSignin" value="true">').submit();
    });
}

$(() => {
    $('#signInButton').on('click', onClick);
    $('#signinCasesModal').get(0).addEventListener('fds.modal.shown', onShowModal);
});